<ng-container *ngIf="type === 'direct'">
  <mat-form-field class="select-users">
    <mat-chip-list #chipList>
      <mat-chip *ngFor="let user of selectedUsers; trackBy: trackUser" (removed)="removeUser(user)">
        {{ user.fullName }}
        <sn-icon matChipRemove>cancel</sn-icon>
      </mat-chip>
      <input
        #input
        matInput
        [placeholder]="'map.createChannel.searchUsers' | t"
        [formControl]="usersControl"
        [matChipInputFor]="chipList"
      />
    </mat-chip-list>
    <mat-hint>
      <mat-error *ngIf="hasError">{{ 'map.createChannel.addAtLeastOneUser' | t }}</mat-error>
    </mat-hint>
  </mat-form-field>
  <div class="users-container">
    <mat-spinner class="users-loader" diameter="48" strokeWidth="4" *ngIf="isLoading">
    </mat-spinner>
    <div class="users-list" *ngIf="!isLoading">
      <div
        class="users-list__item"
        *ngFor="let user of users; trackBy: trackUser"
        (click)="addUser(user)"
      >
        <sn-avatar size="32" [name]="user.fullName"></sn-avatar>
        <div class="userInfo">
          <span class="userName chat-user-select__user-name">{{ user.fullName }}</span>
          <span>{{ user.email }}</span>
          <span class="userLastActive">
            <sn-user-last-active
              [user]="user"
              dateFormat="mediumDate"
              [prefix]="'map.createChannel.lastActive' | t"
            ></sn-user-last-active>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="type === 'organization'">
  <mat-form-field class="chat-user-select__form-field" appearance="fill">
    <mat-label>{{ 'map.createChannel.members' | t }}</mat-label>
    <mat-chip-list #chipList>
      <mat-chip *ngFor="let user of selectedUsers; trackBy: trackUser" (removed)="removeUser(user)">
        {{ user.fullName }}
        <sn-icon matChipRemove>cancel</sn-icon>
      </mat-chip>

      <input
        [formControl]="usersControl"
        #input
        [placeholder]="'map.createChannel.typeName' | t"
        [matChipInputFor]="chipList"
        [matAutocomplete]="auto"
      />
    </mat-chip-list>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addUser($event)">
      <mat-option
        *ngFor="let user of users | snUserFilter : input.value; trackBy: trackUser"
        [value]="user"
      >
        <span class="userName mr-2">{{ user.fullName }}</span>
        <span [matTooltip]="user.email">({{ user.email }})</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>
